import { MappingMode } from "../mapping/service";
import { UnifiedFieldType } from "./service";

/**
 * Flattens a field's type choice (Mapped/Glossary) and, for Mapped only, its mode choice (Direct/
 * Substitute/Format/Conditional) into ONE picker: the actual behaviors on offer are five flat
 * options, so there is one dropdown for that, chosen FIRST (before the destination field), on both
 * the add flow and an already-resolved row — a row can switch between any of the five in place;
 * see `FieldsScreen.tsx`'s `handleTypeChange`.
 */
export type CombinedFieldMode =
  | "direct"
  | "match"
  | "format"
  | "conditional"
  | "glossary";

export const COMBINED_FIELD_MODES: CombinedFieldMode[] = [
  "direct",
  "match",
  "format",
  "conditional",
  "glossary",
];

export const unifiedTypeFor = (mode: CombinedFieldMode): UnifiedFieldType =>
  mode === "glossary" ? mode : "mapped";

export const mappingModeFor = (mode: CombinedFieldMode): MappingMode =>
  mode === "direct" ||
  mode === "match" ||
  mode === "format" ||
  mode === "conditional"
    ? mode
    : "direct";

/** The combined value that best describes an existing entry — a Mapped entry's own `mode`
 *  (falling back to `"direct"` for the legacy `"unmapped"` placeholder value), or `"glossary"`
 *  for the other type. */
export const combinedModeFor = (entry: {
  type: UnifiedFieldType;
  mode?: MappingMode | "unmapped";
}): CombinedFieldMode => {
  if (entry.type === "glossary") {
    return entry.type;
  }
  return entry.mode && entry.mode !== "unmapped" ? entry.mode : "direct";
};
